import { useModalStore } from '@/store/useModal'
import { ModalsRegisterPatient } from '../../../RegisterPatient.constants'
import { EligibilityWellhubData } from '../../../RegisterPatient.types'
import { useState } from 'react'

const useEligibilityWellhubCheckModal = (
  eligibilityData?: EligibilityWellhubData,
) => {
  const { modalOpen, closeModal, showModal } = useModalStore()
  const [copied, setCopied] = useState(false)
  const opened = modalOpen === ModalsRegisterPatient.ELIGIBILITY_CHECK_WELLHUB
  const handleEligibilityCheckModal = () => {
    showModal(ModalsRegisterPatient.ELIGIBILITY_CHECK_WELLHUB)
  }

  const handleCopy = () => {
    if (eligibilityData?.externalId) {
      navigator.clipboard.writeText(eligibilityData.externalId)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    }
  }

  return {
    modalOpen,
    closeModal,
    handleEligibilityCheckModal,
    handleCopy,
    copied,
    opened,
  }
}

export default useEligibilityWellhubCheckModal
